<template>
  <LogInModal>
    <p>{{ t('password_forgotten.description') }}</p>
    <form @submit="reset">
      <LogInField
        v-model="formData.email"
        :placeholder="t('password_forgotten.email')"
      />

      <LogInModalSaveButton>{{
        t('password_forgotten.reset')
      }}</LogInModalSaveButton>
      <LocaleSelectorLogin />
      <LogInModalBackLink :to="{ path: `/` }">
        {{ t('password_forgotten.to_front') }}
      </LogInModalBackLink>
    </form>
  </LogInModal>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from '@/composables/useI18n'
import LogInModal from '@/components/LogInModal'
import LogInField from '@/components/LogInField'
import LogInModalSaveButton from '@/components/LogInModalSaveButton'
import LogInModalBackLink from '@/components/LogInModalBackLink'
import LocaleSelectorLogin from '@/components/LocaleSelectorLogin'

import router from '@/routes'

export default {
  name: 'PasswordForgotten',
  components: {
    LogInModal,
    LogInField,
    LogInModalSaveButton,
    LogInModalBackLink,
    LocaleSelectorLogin,
  },
  setup() {
    const store = useStore()
    const { t } = useI18n()

    const formData = ref({
      email: '',
    })

    const reset = event => {
      event.preventDefault()

      store
        .dispatch('sendResetInstructions', formData.value)
        .then(() => {
          router.push({ name: 'LogIn' })
          store.dispatch('showFlashMessage', {
            message: t('flash_messages.custom.password_forgotten_success'),
          })
        })
        .catch(e => {
          store.dispatch('showFlashMessage', {
            message: t('flash_messages.custom.password_forgotten_error'),
          })
        })
    }

    return {
      formData,
      reset,
    }
  },
}
</script>

<style lang="scss">
@import 'style.scss';
</style>
